<div class="h-screen flex flex-col">
  <app-header class="shrink-0" (menuToggle)="toggleSideMenu()"></app-header>
  <div class="flex flex-1 min-h-0 relative">
    <!-- Desktop side menu - hidden on small screens -->
    <div class="shrink-0 hidden lg:block">
      <app-side-menu></app-side-menu>
    </div>
    
    <!-- Mobile overlay -->
    @if (isSideMenuOpen()) {
      <div 
        class="fixed inset-0 bg-black/50 z-40 lg:hidden"
        (click)="closeSideMenu()"
      ></div>
    }
    
    <!-- Mobile side menu -->
    <div 
      class="fixed top-0 left-0 h-full z-50 transform transition-transform duration-300 lg:hidden"
      [class.translate-x-0]="isSideMenuOpen()"
      [class.-translate-x-full]="!isSideMenuOpen()"
    >
      <app-side-menu (closeMenu)="closeSideMenu()"></app-side-menu>
    </div>
    
    <div class="flex-1 p-4 overflow-auto min-h-0">
      <router-outlet></router-outlet>
    </div>
  </div>
  
  @if (showNotificationPrompt()) {
    <app-notification-dialog
      (dismiss)="dismissNotificationPrompt()" 
      (enable)="enableNotifications()" 
    />
  }
</div>